export default {
    install: (Vue) => {
        Vue.prototype.$APIUpload = function (file, responseCall, addition = null) {
            this.axios.interceptors.response.use(
                (response) => {
                    return response;
                },
                (error) => {
                    return error;
                },
            );

            let formData = new FormData();
            formData.append('file', file);
            if (addition != null) {
                for (let key in addition) {
                    formData.append(key, addition[key]);
                }
            }

            this.axios({
                method: 'post',
                url: this.$getSettings('API_BASE') + 'upload',
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                withCredentials: true,
            }).then(function (response) {
                if (response.status == 200) {
                    responseCall(response.data);
                }
            });
        };

        Vue.prototype.$APIUpload2 = function (file, responseCall, addition = null) {
            const allowedMimeTypes = ['application/pdf', 'image/jpeg', 'image/png'];

            if (!allowedMimeTypes.includes(file.type)) {
                responseCall({error: 'Invalid file type. Only PDF, PNG and JPEG files are allowed.'});
                return;
            }

            this.axios.interceptors.response.use(
                (response) => {
                    return response;
                },
                (error) => {
                    return error;
                },
            );

            let formData = new FormData();
            formData.append('file', file);
            if (addition != null) {
                for (let key in addition) {
                    formData.append(key, addition[key]);
                }
            }

            this.axios({
                method: 'post',
                url: this.$getSettings('API_BASE') + 'seafarer-navigations-file-upload/' + this.$route.params.id,
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                withCredentials: true,
            }).then(function (response) {
                if (response.status == 200) {
                    responseCall(response.data);
                }
            });
        };

        Vue.prototype.$APICall = function (
            method,
            service,
            data,
            responseCall,
            showLoader = true,
            responseType = 'json',
            files = null,
        ) {
            if (files == null) {
                let properties = {
                    method: method,
                    url: this.$getSettings('API_BASE') + service,
                    json: true,
                    withCredentials: true,
                    headers: {},
                    responseType: responseType,
                };
                if (method == 'put' || method == 'post' || method == 'patch') {
                    properties.data = data;
                } else {
                    properties.params = data;
                }
                if (showLoader) {
                    this.$myStore.commit('increaseLoaderCount');
                }

                let vm = this;
                this.axios(properties).then(
                    function (response) {
                        if (showLoader) {
                            vm.$myStore.commit('decreaseLoaderCount');
                        }
                        responseCall(response.data, true);
                    },
                    function (error) {
                        if (showLoader) {
                            vm.$myStore.commit('decreaseLoaderCount');
                        }
                        let errorData = error.response && error.response.data ? error.response.data : undefined;
                        responseCall(errorData, false);
                    },
                );
            } else {
                let formData = new FormData();

                for (let key in files) {
                    formData.append(key, files[key]);
                }

                for (let key in data) {
                    if (typeof data[key] != 'object') {
                        formData.append(key, data[key]);
                    } else {
                        formData.append(key, JSON.stringify(data[key]));
                    }
                }

                if (showLoader) {
                    this.$myStore.commit('increaseLoaderCount');
                }

                let vm = this;
                this.axios({
                    method: method,
                    url: this.$getSettings('API_BASE') + service,
                    data: formData,
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    withCredentials: true,
                }).then(
                    function (response) {
                        if (showLoader) {
                            vm.$myStore.commit('decreaseLoaderCount');
                        }
                        responseCall(response.data, true);
                    },
                    function (error) {
                        if (showLoader) {
                            vm.$myStore.commit('decreaseLoaderCount');
                        }
                        let errorData = error.response && error.response.data ? error.response.data : undefined;
                        responseCall(errorData, false);
                    },
                );
            }
        };
    },
};
